<template>
  <el-config-provider :locale="locale">
    <Layout v-if="$route.meta.isNeedLayout" />
    <router-view  v-else />
  </el-config-provider>
</template>

<script setup>
import Layout from '@/layout/LayoutIndex.vue'
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { ref } from "vue";
let locale = ref("");
locale.value = zhCn;

</script>

<style>
</style>
